export function createCreationMethods(api) {
    return {
        async listCampaigns() {
            const {data} = await api.gamemasterCampaignsList();
            return data;
        },

        async getCampaign(campaignId) {
            const {data} = await api.gamemasterCampaignsRetrieve(campaignId);
            return data;
        },

        async createCampaign({name, description}) {
            const {data} = await api.gamemasterCampaignsCreate({name, description});
            return data;
        },

        async updateCampaignBasics(campaignId, {name, description} = {}) {
            const {data} = await api.gamemasterCampaignsPartialUpdate(campaignId, {name, description});
            return data;
        },

        /**
         * @param {string} campaignId
         * @param {File} image
         */
        async uploadBackgroundImage(campaignId, image) {
            const form = new FormData();
            form.append('image', image);
            const {data} = await api.gamemasterCampaignsBackgroundImageCreate(campaignId, form);
            return data;
        },

        async cloneCampaign(campaignId, {name, description} = {}) {
            const {data} = await api.gamemasterCampaignsCloneCreate(campaignId, {name, description});
            return data;
        },
    };
}
